import {takeLatest} from 'redux-saga/effects';
import * as types from "../constants/actionTypes";
import {
	fetchObjectDataSaga,
} from './objectDataSaga';

import {
	areaFiltersSaga,
	rentFiltersSaga,
	searchFiltersSaga
} from './filtersSaga';

import {
	fetchGlobalSearchSaga
} from './globalSearchSaga';

export function* watchObjectData() {
	yield takeLatest(types.FETCH_OBJECTDATA, fetchObjectDataSaga);
}
// export function* watchRealestate() {
// 	yield takeLatest(types.FETCH_REALESTATE, fetchRealestateSaga);
// }
export function* watchAreaFiltersSaga() {
	yield takeLatest( types.FETCH_AREA_FILTERS, areaFiltersSaga)
}
export function* watchRentFiltersSaga() {
	yield takeLatest( types.FETCH_RENT_FILTERS, rentFiltersSaga)
}
export function* watchSearchFiltersSaga() {
	yield takeLatest( types.FETCH_SEARCH_FILTERS, searchFiltersSaga)
}
export function* watchGlobalSearchSaga() {
	yield takeLatest( types.FETCH_GLOBAL_SEARCH, fetchGlobalSearchSaga)
}



// WEBPACK FOOTER //
// ./src/js/sagas/watcher.js